import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=ef0f2174"
import script from "./Turno.vue?vue&type=script&lang=js"
export * from "./Turno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports